import ApplicationController from '../application_controller'
import { useBusItem } from '@app/javascript/controllers/mixins/useBusItem.js'
import tippy from 'tippy.js'

export default class extends ApplicationController {
  static values = { options: Object }

  doConnect() {
    useBusItem(this)
    this.initializeValues()
    this.tooltip = tippy(
      this.element,
      Object.assign(this.defaultOptions, this.optionsValue)
    )
  }

  doDisconnect() {
    this.tooltip.destroy()
    this.removeFromBus()
  }

  reset() {
    this.doDisconnect()
    this.doConnect()
  }

  initializeValues() {
    if (!this.hasOptionsValue) {
      this.optionsValue = { content: 'Missing to define tooltip options' }
    }
  }

  get defaultOptions() {
    return {
      allowHTML: true,
      theme: 'fiscalnote',
      trigger: 'mouseenter click'
    }
  }
}
